import { render, staticRenderFns } from "./ElFlexWrapperBox.vue?vue&type=template&id=8bfd49ea"
import script from "./ElFlexWrapperBox.vue?vue&type=script&lang=js"
export * from "./ElFlexWrapperBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports